import { render, staticRenderFns } from "./ListDiscount.vue?vue&type=template&id=c08e51f6"
import script from "./ListDiscount.vue?vue&type=script&lang=js"
export * from "./ListDiscount.vue?vue&type=script&lang=js"
import style0 from "./ListDiscount.vue?vue&type=style&index=0&id=c08e51f6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c08e51f6')) {
      api.createRecord('c08e51f6', component.options)
    } else {
      api.reload('c08e51f6', component.options)
    }
    module.hot.accept("./ListDiscount.vue?vue&type=template&id=c08e51f6", function () {
      api.rerender('c08e51f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Ingenes/ListDiscount.vue"
export default component.exports